import React from 'react'
import { RealEstateDataPageComponentData } from 'types'

const BlogCard_3v1_01 = (props: RealEstateDataPageComponentData) => {
  const Card = require(`../1`)?.default
  const hidenTags = true
  const hidenAuthor = true
  const placeholder = ''
  const upperCaseLink = false
  const { novelty, tags, skeleton, keyIndex }: any = props
  return (
    <Card
      hidenTags={hidenTags}
      tags={tags}
      skeleton={skeleton}
      hidenAuthor={hidenAuthor}
      isSummaryCard={true}
      novelty={novelty}
      placeholder={placeholder}
      upperCaseLink={upperCaseLink}
      dateFormat={props.dateFormat}
      keyIndex={keyIndex}
      {...props}
    />
  )
}

export default BlogCard_3v1_01
